import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

// Layout passthrough for /invite/* child routes.
// Direct navigation to /invite (without a token) renders nothing useful,
// so redirect to login as a fallback. Users should arrive here via an invitation
// email link that includes a token in the path.
export const Route = createFileRoute('/(public)/invite')({
  beforeLoad: ({ location }) => {
    // Only redirect if this is an exact match on the parent route (no token segment).
    // Child routes like /invite/:token are unaffected.
    if (location.pathname === '/invite') {
      throw redirect({ to: '/login', replace: true });
    }
  },
  component: () => <Outlet />,
});
